import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from '@firebase/auth';

@Injectable()
export class LoginService {
  public errorMessages: string[] = [];
  
  constructor(private app: AppService) {
  }

  login(username: string, password: string) {
    signInWithEmailAndPassword(this.app.firebaseAuth, username, password)
    .then(() => {
      this.app.fetchUserRecord();
    })
    .catch ((error) => {
      console.log(error);
      this.errorMessages = [];
      this.errorMessages.push('Login failed. Invalid Email or Password');
    });
  }

  passwordReset(email: string): Promise<void> {
    return sendPasswordResetEmail(this.app.firebaseAuth, email);
  }
}